module.exports = __webpack_public_path__ + "static/media/snappy-success.2c71e97f.svg";